<script>
import CreateAccount from '@/components/CreateAccount'
import EnvironmentUtils from '@/utils/environmentUtils'
import CitiesServices from '@/services/cities'

export default
{
    name: 'create-admin-account',

    render () 
    {
        return (
            <div id='create-admin-account-view'>
                <create-account on-account-created={this.onAccountCreated} />
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    watch:
    {
    },

    mounted ()
    {
    },

    methods:
    {
        async onAccountCreated (accountDetails)
        {
            const token = this.$store.state.user.token
            const cityId = EnvironmentUtils.cityId

            const newPrivileges = await CitiesServices.setUserPrivileges(cityId, token, accountDetails.id, { isAdministrator: true })
            this.$store.dispatch('cities/fetchAdministratorAccount', { cityId, token, accountId: accountDetails.id })

            console.log('Set account', accountDetails.id, 'to administrator with privileges', newPrivileges)
        },
    },

    components:
    {
        CreateAccount
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#create-admin-account-view
{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 80vh;
    margin-top: var(--theme-status-bar-height);
    margin-bottom: var(--theme-horizontal-menu-height);

    .OnDesktop({
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    .create-account
    {
        width: 95vw;

        .OnTablet({ width: 70vw; });
        .OnDesktop({ width: 450px; });
    }
}
</style>



// WEBPACK FOOTER //
// src/views/CreateAdminAccount.vue